import Yup from 'utils/validation/yup-extensions';
import {
	FORM_INITIAL_VALUES as USER_TYPE_INITIAL_VALUES,
	FORM_VALIDATION_SCHEMA_OBJECT as USER_TYPE_VALIDATION_SCHEMA_OBJECT,
} from '../../../components/UI/Input/Custom/UserType/_constants';
import { REGEX_EMAIL } from '../../../utils/strings/StringUtil';
import { FORM_INITIAL_VALUES as HOME_ADDRESS_INITIAL_VALUES } from './components/AddressGroup/HomeAddressGroup/_constants';

export const CSS_CLASSES = {
	DIVIDER: 'divider',
	FORM_BODY: 'form-body',
	FOOTER: 'footer',
	LABEL_RADIO_SET: 'radio-set__label',
	LABEL_WARNING_RADIO_SET: 'radio-set__label--warning',
	LABEL_AGREEMENT_TEXT: 'label--agreement-text',
};

export const FORM_KEYS = {
	ALTERNATE_EMAIL_ADDRESS: 'ALTERNATE_EMAIL_ADDRESS',
	COMPUTER_ACCESS_OPTIONS: 'RADIO_SET_COMPUTER_ACCESS',
	COMPUTER_ACCESS: 'RADIO_COMPUTER_ACCESS',
	DEPARTMENT_ID: 'DEPARTMENT_ID',
	DEPARTMENT_UNIT: 'DEPARTMENT_UNIT',
	HOSPITAL_AFFILIATION: 'HOSPITAL_AFFILIATION',
	NO_COMPUTER_ACCESS: 'RADIO_NO_COMPUTER_ACCESS',
	SPONSORING_DEPARTMENT: 'SPONSORING_DEPARTMENT',
	SPONSOR_ACKNOWLEDGMENT: 'SPONSOR_ACKNOWLEDGMENT',
};

export const USER_TYPES = {
	EPIC_LINK_USER: 'EpicCare Link User'.toLocaleLowerCase(),
	TENANT_BADGE_ONLY: 'Tenant Badge Only'.toLowerCase(),
	REGULATORY_USER: 'Regulatory User'.toLowerCase(),
};

export const TENANT_BADGE_ONLY_INITIAL_VALUES = {
	[`${FORM_KEYS.ALTERNATE_EMAIL_ADDRESS}`]: '',
	[`${FORM_KEYS.DEPARTMENT_UNIT}`]: '',
	[`${FORM_KEYS.DEPARTMENT_ID}`]: '',
	[`${FORM_KEYS.HOSPITAL_AFFILIATION}`]: '',
	[`${FORM_KEYS.SPONSORING_DEPARTMENT}`]: '',
	...USER_TYPE_INITIAL_VALUES,
	...HOME_ADDRESS_INITIAL_VALUES,
};

export const TENANT_BADGE_ONLY_VALIDATION_SCHEMA_OBJECT = {
	[`${FORM_KEYS.ALTERNATE_EMAIL_ADDRESS}`]: Yup.string()
		.matches(REGEX_EMAIL, 'Please provide a valid email address format.')
		.required('An alternate email is required.'),
	[`${FORM_KEYS.DEPARTMENT_ID}`]: Yup.string().required(
		'Please select a valid department.'
	),
	[`${FORM_KEYS.HOSPITAL_AFFILIATION}`]: Yup.string().required(
		'A hospital affiliation is required.'
	),
	...USER_TYPE_VALIDATION_SCHEMA_OBJECT,
	[`${FORM_KEYS.SPONSORING_DEPARTMENT}`]: Yup.string().required(
		'A sponsoring department is required.'
	),
};

export const SPONSOR_ACKNOWLEDGMENT_SCHEMA_OBJECT = {
	[`${FORM_KEYS.SPONSOR_ACKNOWLEDGMENT}`]: Yup.bool().oneOf(
		[true],
		'Acknowledgment required.'
	),
};
